/**
 * External Dependencies
 */
import 'jquery';
//import 'bootstrap'; // Keep bootstrap out of this in order for the site to work in IE11 (...). Lets get it from a CDN instead.
import './polyfills';
import BootstrapFixes from './BootstrapFixes';
import EcGoogleMaps from './EcGoogleMaps';
import LazyLoad from 'vanilla-lazyload/dist/lazyload';
import SiteHeader from './SiteHeader';

$(document).ready(() => {

  BootstrapFixes.init();

  new LazyLoad({
    elements_selector: '[data-echocrate-do-lazy-load]',
    use_native: false,
    class_loaded: 'lazy-loaded',
    callback_loaded: function(el) {
      let closest = el.closest('.lazy-load-wrapper');
      if(closest) {
        closest.classList.add('lazy-loaded-wrapper');
      }
    },
  });

  SiteHeader.init();

  jQuery('.employee-teaser__contact').on('click', function(event) {
    event.preventDefault();
    jQuery('.employee-teaser').removeClass('employee-teaser--active');
    jQuery(this).parents('.employee-teaser').toggleClass('employee-teaser--active');
  });

  jQuery('#filter_year').change(function() {
    this.form.submit();
  });

  jQuery('#filter_category').change(function() {
    this.form.submit();
  });

});
